import React from 'react';
import { useDispatch } from 'react-redux';
import Button from '@material-ui/core/Button';
import { Box } from '@material-ui/core';
import { alpha, makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { AuhMethods } from '../../../../services/auth';
import ContentLoader from '../../ContentLoader';
import CmtImage from '../../../../@coremat/CmtImage';
import IntlMessages from '../../../utils/IntlMessages';
import { CurrentAuthMethod } from '../../../constants/AppConstants';
import AuthWrapper from './AuthWrapper';
import { getApiHost } from '../../../../services/config';

const useStyles = makeStyles((theme) => ({
	authThumb: {
		backgroundColor: alpha(theme.palette.primary.main, 0.12),
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		padding: 20,
		width: '100%',
		[theme.breakpoints.up('md')]: {
			width: '50%',
			order: 2,
		},
	},
	authContent: {
		padding: 30,
		width: '100%',
		[theme.breakpoints.up('md')]: {
			width: (props) => (props.variant === 'default' ? '50%' : '100%'),
			order: 1,
		},
		[theme.breakpoints.up('xl')]: {
			padding: 50,
		},
	},
	titleRoot: {
		marginBottom: 14,
		color: theme.palette.text.primary,
	},
	textFieldRoot: {
		'& .MuiOutlinedInput-notchedOutline': {
			borderColor: alpha(theme.palette.common.dark, 0.12),
		},
	},
	formcontrolLabelRoot: {
		'& .MuiFormControlLabel-label': {
			[theme.breakpoints.down('xs')]: {
				fontSize: 12,
			},
		},
	},
}));

// variant = 'default', 'standard'
const SignIn = ({ method = CurrentAuthMethod, variant = 'default', wrapperVariant = 'default' }) => {
	const dispatch = useDispatch();
	const classes = useStyles({ variant });

	const onSubmit = () => {
		window.location.href = `${getApiHost()}/oauth/google`;
	};

	return (
		<AuthWrapper variant={wrapperVariant}>
			<Box className={classes.authThumb}>
				<CmtImage src='/images/auth/login-img.png' />
			</Box>
			<Box className={classes.authContent}>
				<Box mb={7}>
					<CmtImage src='/images/logo.png' />
				</Box>
				<Typography component='div' variant='h1' className={classes.titleRoot}>
					Login
				</Typography>
				<form>
					<Box display='flex' alignItems='center' justifyContent='space-between' mb={5}>
						<Button onClick={onSubmit} variant='contained' color='primary'>
							<IntlMessages id='appModule.signIn' />
						</Button>
					</Box>
				</form>

				{dispatch(AuhMethods[method].getSocialMediaIcons())}

				<ContentLoader />
			</Box>
		</AuthWrapper>
	);
};

export default SignIn;
